import { UiState } from '@marketplace-web/shared/ui-state'
import { ConfigurationState } from '@marketplace-web/catalog/catalog-data'

import { ConfigurationAction, ConfigurationReducerAction } from './actionTypes'

export const configurationReducer = (
  state: ConfigurationState,
  action: ConfigurationAction,
): ConfigurationState => {
  switch (action.type) {
    case ConfigurationReducerAction.FETCH_CONFIG_REQUEST: {
      return {
        ...state,
        ui: {
          ...state.ui,
          uiState: UiState.Pending,
        },
      }
    }
    case ConfigurationReducerAction.FETCH_CONFIG_SUCCESS: {
      const { currency, locale } = action.payload

      return {
        ...state,
        ui: {
          ...state.ui,
          uiState: UiState.Success,
        },
        config: {
          currency,
          locale,
        },
      }
    }
    case ConfigurationReducerAction.FETCH_CONFIG_FAILURE: {
      return {
        ...state,
        ui: {
          ...state.ui,
          uiState: UiState.Failure,
        },
      }
    }
    default:
      return state
  }
}
